import {environment} from './environment.prod';
export {environment};